import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';

function ToggleSwitch(props){
    const {isChecked,name,handleChange,disabled,label} = props;
    const {t} =useTranslation();
    const toggleHandler = (e) =>{
        e.preventDefault();
        const charCode = typeof e.which === "undefined" ? e.keyCode : e.which;
        if(charCode === 13){
            handleChange(!isChecked)
        }
    }
    return(
        <>
            <Form.Group>
                <Form.Label htmlFor={name} className="toggle-label">
                    <Form.Check
                        className="form-checkbox"
                        type='checkbox'
                    >
                        <div className={`toggleSwitch ${isChecked ? 'toggled' :''}`} onKeyUp={(e)=>toggleHandler(e)} aria-label={t(label)}
                        tabIndex={0}>
                            <div className='switch'>
                            <Form.Check.Input
                                type="checkbox"
                                name={name}
                                id={name}
                                checked={isChecked}
                                onChange={(e) => handleChange(e.target.checked)}
                                disabled={disabled}
                                tabIndex={-1}
                            />
                            </div>
                        </div>
                        
                    </Form.Check>
                </Form.Label>
                
            </Form.Group>
        </>
    )
}
ToggleSwitch.propTypes={
    name:PropTypes.string.isRequired,
    isChecked:PropTypes.bool.isRequired,
    handleChange:PropTypes.func.isRequired,
    disabled:PropTypes.bool
}
ToggleSwitch.defaultProps = {
    disabled: false,
  };
export default ToggleSwitch;